import {useTranslation} from '@/translations/i18n'
import {Divider} from '@/components/ui/divider/Divider'
import {FormSection} from '@/components/commons/form-section/FormSection'
import {MedicalReportSectionTitle} from '../medical-report-section-title/MedicalReportSectionTitle'
import {HobbiesField} from '../hobbies-field/HobbiesField'
import {SchoolFields} from '../school-fields/SchoolFields'
import {FamilySituationMinorsField} from '../family-situation-minors-field/FamilySituationMinorsField'

export const InterestsSections = () => {
    const {t} = useTranslation()

    return (
        <>
            <MedicalReportSectionTitle>{t('medical_records:hobbies_title')}</MedicalReportSectionTitle>
            <FormSection title={t('medical_records:hobbies_notes')}>
                <HobbiesField />
            </FormSection>
            <Divider direction="horizontal" />
            <FormSection title={t('medical_records:school_section_title')}>
                <SchoolFields />
            </FormSection>
            <Divider direction="horizontal" />
            <FormSection title={t('medical_records:family_situation_minors')}>
                <FamilySituationMinorsField />
            </FormSection>
        </>
    )
}
